import { render, staticRenderFns } from "./section-preview.vue?vue&type=template&id=9c0cbcfe&scoped=true&"
import script from "./section-preview.vue?vue&type=script&lang=js&"
export * from "./section-preview.vue?vue&type=script&lang=js&"
import style0 from "./section-preview.vue?vue&type=style&index=0&id=9c0cbcfe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0cbcfe",
  null
  
)

export default component.exports